









































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {HomeShop} from '@/static/home';
import {Action} from 'vuex-class';
import {CommonActionTypes} from '@/store/actions/types';
import {BranchListMessages, StoreFacilitiesMessages} from '@/maps/common';

const Tactics = {
  mapContainerId: 'container',
  /**地图初始化*/
  mapInit(branch: BranchListMessages) {
    // @ts-ignore
    return new TMap.Map(document.getElementById(Tactics.mapContainerId), {
      // @ts-ignore
      center: new TMap.LatLng(branch.map.lat, branch.map.lon),
      pitch: 45,
      showControl: true
    });
  },
  /**地图移动*/
  mapPanTo(map: TMap, branch: BranchListMessages) {
    map.setZoom(13);
    // @ts-ignore
    map.panTo({lat: branch.map.lat, lng: branch.map.lon});
  },
  /**标注*/
  mapMultiMarker(map: TMap, branchList: Array<BranchListMessages>, clickEvent?: Function) {
    // @ts-ignore
    let geometriesList: Array<PointGeometry> = branchList.map(branch => {
      return {
        id: branch.key + '',
        styleId: {
          // @ts-ignore
          'marker': new TMap.MarkerStyle({
            'width': 25,
            'height': 35,
            'anchor': {x: 16, y: 32},
            // 'src': 'img/marker.png'
          })
        },
        // @ts-ignore
        position: new TMap.LatLng(branch.map.lat, branch.map.lon),
        properties: {
          'title': branch.shopName
        }
      };
    });
    // @ts-ignore
    new TMap.MultiMarker({
      id: 'store',
      styles: {
        // @ts-ignore
        'marker': new TMap.MarkerStyle({
          'width': 25,
          'height': 35,
          'anchor': {x: 16, y: 32},
          // 'src': 'img/marker.png'
        })
      },
      map: map,
      geometries: geometriesList
    }).on('click', (res: any) => {
      map.panTo(res.geometry.position);
      clickEvent!(res.geometry.id);
    });
  }
};
@Component
export default class HomeShopView extends Vue {
  private pageData = HomeShop;
  private storeActive: number = -1;
  private branchData: Array<BranchListMessages> = [];
  private map: TMap | undefined;
  private storeFacilities: Array<StoreFacilitiesMessages> = [];

  @Action(CommonActionTypes.GET_BRANCH_LIST)
  private getBranchList!: () => Promise<Array<BranchListMessages>>;


  @Action(CommonActionTypes.GET_STORE_FACILITIES)
  private getStoreFacilities!: (params: { store_id: number }) => Promise<any>;

  @Watch('branchData')
  public async onBranchData(val: Array<BranchListMessages>, oldVal: Array<BranchListMessages>) {
    if (oldVal.length == 0) {
      this.branchData = val;
      this.map = Tactics.mapInit(this.branchData[0]);
      this.storeFacilities = await this.getStoreFacilities({store_id: this.branchData[0].key});
      Tactics.mapMultiMarker(this.map!, this.branchData, (id: number) => {
        this.storeActive = +id;
      });
    }
  }

  async created() {
    this.branchData = await this.getBranchList();
    this.storeActive = this.branchData[0].key;
  }

  mounted() {
  }

  /**门店切换*/
  public async onTabChange(event: number) {
    let shop: BranchListMessages | undefined = this.branchData.find((dist) => {
      this.storeActive = event;
      return dist.key == event;
    });
    Tactics.mapPanTo(this.map!, shop!);
    this.storeFacilities = await this.getStoreFacilities({store_id: shop!.key});
  }


}
